import { UploadIcon } from 'assets/icons';
import CancelSelectionButton from 'Components/Form/SearchDropDown/CancelSelectionButton';
import { useDropzone } from 'react-dropzone';

export default function FileInput({
  value,
  onChange,
}: {
  value?: File;
  onChange?: (file?: File) => void;
}) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (f) => {
      onChange && onChange(f[0]);
    },
  });

  return (
    <>
      <div
        {...getRootProps()}
        style={{ height: '42px' }}
        className={`px-3 border border-gray-100 focus-within:border-gray-light rounded-xl cursor-pointer w-full ${
          isDragActive ? 'border-2' : ''
        }`}
      >
        <label
          className={`cursor-pointer flex items-center gap-x-2 h-full text-sm`}
        >
          <input
            type="file"
            className="hidden"
            onChange={(e) =>
              e.target.files && onChange && onChange(e.target.files[0])
            }
          />

          <div className="flex flex-1 justify-between items-center  text-gray-700">
            {!value && (
              <>
                <div>Upload or drop file</div>
                <UploadIcon className="" />
              </>
            )}
            {value && (
              <>
                <div className="text-gray-dark ">{value.name}</div>
                <CancelSelectionButton
                  onClick={() => onChange && onChange(undefined)}
                />
              </>
            )}
          </div>
        </label>
      </div>
    </>
  );
}
